import React from 'react';

import WhyChooseUs from './WhyChooseUs';
import AboutSectionTwo from './AboutSectionTwo';

const Aboutus = () => {
  return (
    <>

<section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
       <h1>Rooms</h1>
    </div>
  </div>
</section>


  
      <div className="dark_bg">
        <section className="welcome-section-six light-bg mx-60 border-shape-top">
          <div className="auto-container">
            <div className="row">

              {/* Left Column */}
              <div className="col-lg-6">
                <div className="title-box">
                  <div className="sub-title">welcome to woodland escape </div>
                  <h2 className="sec-title small mb-30">
                    Experience nature’s calm <br /> in the heart of the forest
                  </h2>
                  {/* <div className="text">
                    A peaceful getaway surrounded by lush greenery and the soothing sounds of nature.
                  </div> */}
                  <div className="text-two">
                    Woodland Escape is designed for those who seek tranquility, comfort, and a touch of adventure. 
                    Located deep in the forest, our offers guests an opportunity to relax amidst nature and, 
                    if lucky, witness the majestic tigers and other wildlife in their natural habitat. 
                    From cozy cottages to spacious villas, every stay is crafted to connect you with the wilderness.
                  </div>
                  <div className="text-three">
                    Enjoy delicious meals, unwind by the pool, or join a guided forest walk to explore the beauty around you. 
                    Whether you’re here for a peaceful retreat, a family outing, or a corporate getaway, Woodland Escape 
                    promises a memorable experience surrounded by nature’s best.
                  </div>

                  {/* Author Info */}
                  {/* <div className="author-info d-flex align-items-center justify-content-between flex-wrap">
                    <div className="author-wrap d-flex align-items-center">
                     
                     
                    </div>
                   
                  </div> */}
                </div>
              </div>

              {/* Right Column */}
              <div className="col-lg-6">
                <div className="text-lg-end">
                  <div className="image">
                    {/* <img src={welcomeImage} alt="Woodland Escape " /> */}
                    <img src="/images/455-600.jpg"alt="Woodland Escape " />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        <WhyChooseUs />
        {/* <AboutSectionTwo /> */}
      </div>
    </>
  );
};

export default Aboutus;
